import {useContext} from 'react';
import {Context} from './context';

export const useConfiguracaoContext = () => {
    const context = useContext(Context);
    return context;
};

